var $$ = $$ || {};

$$.CatalogMenu = class CatalogMenu {
	constructor (root) {

		this.root = root;
		this.rootHeight = $(this.root).height();
		this.rootTopPadding = parseInt($(this.root).position().top, 10);

		this.initialize();

		this._cacheNodes();
		this._bindEvents();
	}

	initialize () {
		$$.body.css({ minHeight: this.rootHeight + this.rootTopPadding });
	}

	_cacheNodes () {
		this.nodes = {
			logo: this.root.find('.js-logo-wrapper'),
			search: this.root.find('.js-search-wrapper'),
			searchInput: this.root.find('.js-menu-search'),
			searchButton: this.root.find('.js-menu-search-button'),
			menu: this.root.find('.js-catalog-menu'),
			notFirstLevel: this.root.find(
				'.js-catalog-menu-second-level,' +
				'.js-catalog-menu-third-level,' +
				'.js-catalog-menu-product-level'
			),
			menuItems: this.root.find('.js-catalog-menu-item')
		};
	}

	_bindEvents () {
		this.root
			.on('mouseenter', (event) => {
				$(event.currentTarget).on('mousewheel', (event) => {
					this._scrollMenu(event, 'root');
				});
			})
			.on('mouseleave', (event) => {
				$(event.currentTarget).off('mousewheel');
			});

		this.nodes.notFirstLevel
			.on('mouseenter', (event) => {
				$(event.currentTarget).on('mousewheel', (event) => {
					this._scrollMenu(event, 'notRoot');
				});
			})
			.on('mouseleave', (event) => {
				$(event.currentTarget).off('mousewheel');
			});
	}

	_scrollMenu (event, level) {
		if ( this.nodes.searchInput.hasClass('focus') ) {
			return;
		}

		var items;
		var itemFirst;
		var fullHeight;
		var scrollStep;
		var marginTop;
		var maxMarginTop;

		if ( level === 'root' ) {
			fullHeight =
				this.nodes.logo.height() +
				this.nodes.search.height() +
				this.nodes.menu.height();
			scrollStep = this.nodes.menu.children(this.nodes.menuItems).height();
			marginTop = parseInt(this.nodes.logo.css('margin-top'), 10);
		} else if ( level === 'notRoot') {
			items = $(event.currentTarget).children(this.nodes.menuItems);
			itemFirst = items.first();
			fullHeight = itemFirst.height() * items.length + parseInt($(event.currentTarget).css('padding-top'), 10);
			scrollStep = itemFirst.height();
			marginTop = parseInt(itemFirst.css('margin-top'), 10);
		}

		maxMarginTop = fullHeight - $$.windowHeight;

		if ( scrollStep > $$.windowHeight ) {
			scrollStep = $$.windowHeight;
		}

		if ( fullHeight > $$.windowHeight ) {
			if ( event.deltaY > 0 ) {
				marginTop = marginTop + scrollStep;
				if ( marginTop > 0 ) {
					marginTop = 0;
				}
			} else if ( event.deltaY < 0 ) {
				marginTop = marginTop - scrollStep;
				if ( marginTop < -maxMarginTop ) {
					marginTop = -maxMarginTop;
				}
			}

			if ( level === 'root' ) {
				this.nodes.logo.css({ marginTop: marginTop });
				this.nodes.searchInput.css({ top: marginTop + 60 });
				this.nodes.searchButton.css({ top: marginTop + 60 });
			} else if ( level === 'notRoot') {
				itemFirst.css({ marginTop: marginTop });
			}
		}
	}
};
